import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE } from 'main/common'
import Page from 'main/components/common/Page'
import { Col, Hidden, Row, Text } from 'main/ui'

import { i18nKeyPrefix as PRE } from './'
import {
  AppButton,
  BoldText,
  FeaturesList,
  IntroText,
  ListItem,
  MainContainer,
  MobileAppButtonWrapper,
  PhoneImageContainer,
  Title,
} from './StaffDownloadApp.styles'

const STORE_LINKS = {
  googlePlay: 'https://play.google.com/store/apps/details?id=com.wonderschool.mobile',
  appStore: 'https://apps.apple.com/us/app/wonderschool/id1455389693',
}

const STORE_LOGOS = {
  googlePlay: 'https://ucarecdn.com/be004991-c6b7-42cc-a062-429786e1a1fa/',
  appStore: 'https://ucarecdn.com/dadf1e19-a976-4132-87bc-038e0558e351/',
}

const PHONE_IMG = 'https://ucarecdn.com/bcce55a0-3049-44f1-a3f0-7ad9ab600596/Group701.png'

function StaffDownloadApp() {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const APP_FEATURES = [
    {
      featureName: `${PRE}-FEATURE-REAL-TIME-UPDATES`,
      featureDescription: `${PRE}-FEATURE-REAL-TIME-UPDATES-TXT`,
    },
    {
      featureName: `${PRE}-FEATURE-MESSAGING`,
      featureDescription: `${PRE}-FEATURE-MESSAGING-TXT`,
    },
    {
      featureName: `${PRE}-FEATURE-CHECK-IN-OUT`,
      featureDescription: `${PRE}-FEATURE-CHECK-IN-OUT-TXT`,
    },
  ]
  return (
    <Page headerParams={{ onlyShowLogo: true }} hideFooter>
      <MainContainer>
        <Row>
          <Hidden xs sm md>
            <Col lg={4}>
              <PhoneImageContainer>
                <img src={PHONE_IMG} alt="Wonderschool app" />
              </PhoneImageContainer>
            </Col>
          </Hidden>
          <Col lg={8}>
            <Title>{t(`${PRE}-TITLE`)}</Title>
            <IntroText>{t(`${PRE}-INTRO-TEXT`)}</IntroText>
            <Hidden lg xl>
              <MobileAppButtonWrapper>{renderAppLinkForMobile()}</MobileAppButtonWrapper>
            </Hidden>
            <FeaturesList>
              {APP_FEATURES.map(({ featureName, featureDescription }) => (
                <ListItem key={featureName}>
                  <BoldText>{t(featureName)}</BoldText>
                  <Text>{t(featureDescription)}</Text>
                </ListItem>
              ))}
            </FeaturesList>
            <Hidden xs sm md>
              {renderAppLinksForWeb()}
            </Hidden>
          </Col>
        </Row>
      </MainContainer>
    </Page>
  )

  function handleOpenStoreLink(url: string) {
    window.open(url, '_blank')
  }

  function renderAppLinksForWeb() {
    return (
      <>
        <AppButton
          alt="Play Store"
          src={STORE_LOGOS.googlePlay}
          onClick={() => handleOpenStoreLink(STORE_LINKS.googlePlay)}
        />
        <AppButton
          alt="App Store"
          src={STORE_LOGOS.appStore}
          onClick={() => handleOpenStoreLink(STORE_LINKS.appStore)}
        />
      </>
    )
  }

  function renderAppLinkForMobile() {
    const userAgent = navigator.userAgent

    if (/android/i.test(userAgent)) {
      return (
        <AppButton
          alt="Play Store"
          src={STORE_LOGOS.googlePlay}
          onClick={() => handleOpenStoreLink(STORE_LINKS.googlePlay)}
        />
      )
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      return (
        <AppButton
          alt="App Store"
          src={STORE_LOGOS.appStore}
          onClick={() => handleOpenStoreLink(STORE_LINKS.appStore)}
        />
      )
    }

    // non-mobile user agent found, just use web
    return renderAppLinksForWeb()
  }
}

export default StaffDownloadApp
